module.exports = __webpack_public_path__ + "img/nopayments.5deeaaf5.png";